import moment from 'moment';
import{ CommonFilters } from 'gcmcn-common';

export default {
    defaultLanguage (){
        return 'en';
    },
    currentSearchTerm: (state, getters) => {
        return state.searchTerm;
    },
    darkMode() {
        return true;
    },
    displayAppSearchBar() {
        return false;
    },
    displayChooseEntityFullOverlay(){
        // DO NOT DISPLAY view Choose Entity
        return false;
    },

    displayAuthFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.userIsAuthenticated;
    },
    shouldFetchModelAclRoles (){
        return true;
    },
    shouldFetchModelAclPermissions (){
        return false;
    },
    displayLoadingFullOverlay(state, getters, rootState, rootGetters){
        return !rootGetters.modelsUnscopedLoaded;
    },
    enableGroupsAdministration(){
        return false;
    },
    enableUsersAdministration(){
        return false;
    },
    enablePermissionAdministration(){
        return false;
    },
    enableGroupsSideBarMenu(){
        return false;
    },
    enableUsersSideBarMenu(){
        return false;
    },
    enableDownloadCsvGroups(){
        return false;
    },
    enableDownloadCsvUsers(){
        return false;
    },
    enableRegister(){
        return false;
    },
    enableResetPassword(){
        return true;
    },
    enableLoginByEmail(){
        return false;
    },
    enableCreateUser(){
        return false;
    },
    enableCreateGroup(){
        return false;
    },
    enableDeleteGroup() {
        return true;
    },
    enableManageNotifications() {
        return false;
    },
    enableManageOtherUsersNotifications() {
        return false;
    },
    loginImage() {
        return '/static/image/login-image.jpg';
    },
    logoFile() {
        return '/static/image/globecast_logo.png';
    },
    backgroundFile1() {
        return '';
    },
    logoFileTopHeader() {
        return '/static/image/logo-white-80x35.png';
    },
    logoFileTopHeaderBackgroundColor(/*state, getters*/) {
        return '#222';
    },
    showAlerts (){
        return true;
    },
    showAlarms (){
        return true;
    },
    menuItemColors (){
        return {
            background: '#222',
            text: '#bbb',
            activeText: '#ffd04b',
        };
    },
    sidebarName() {
        return '';
    },
    userHasMultipleEntities(state, getters) {
        return getters.userEntities.length > 1;
    },
    userEntities(state, getters) {
        let user = getters.currentUser;
        return user.entitys.map(entityUid => {
            return getters.entitiesByUid(entityUid);
        });
    },
    IsUserAllowedToLogin: () => (user) =>{
        if(user.level.toLowerCase() === 'simpleuser'){
            return false;
        }
        return true;
    },

    windowWidth (state){
        return state.ww;
    },

    simpleLayoutV2Heigth (state){
        if(state.ww <= 1024){
            return 145;
        }else{
            return 233;
        }
    },
    pageHeight (state, getters){
        // 65 == topbar
        return 65 + getters.simpleLayoutV2Heigth;
    },
    sortTypeList ( ) {
        return [{name: 'asc', value:'asc'}, {name: 'dsc', value:'dsc'}];
    },

    availableFeedStatus (){
        return  [
            {name: 'AVAILABLE', value: 'AVAILABLE'},
            {name: 'STARTING', value: 'STARTING'},
            {name: 'RUNNING', value: 'RUNNING'},
            {name: 'FINISHED', value: 'FINISHED'}
        ];
    },
    availableChannelStatus (){
        return  [
            {name: 'AVAILABLE', value: 'AVAILABLE'},
            {name: 'PREPARING', value: 'PREPARING'},
            {name: 'STARTING', value: 'STARTING'},
            {name: 'RUNNING', value: 'RUNNING'},
            {name: 'STOPPING', value: 'STOPPING'},
            {name: 'STOPPED', value: 'STOPPED'},
        ];
    },

    orderingFeeds: () =>  (feeds) => {
        let orderedFeeds = [];
        orderedFeeds.push( ...feeds.filter((feed) => CommonFilters.filterByRunningStatus(feed)).sort((a,b)  => {
            return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
        }));
        orderedFeeds.push( ...feeds.filter((feed) => CommonFilters.filterByAvailableFeeds(feed)).sort((a,b)  => {
            return new Date(b.confirmed ? b.confirmed_start_date : b.start_date) - new Date(a.confirmed ? a.confirmed_start_date : a.start_date);
        }));
        orderedFeeds.push( ...feeds.filter((feed) => CommonFilters.filterByFailedStatus(feed)).sort((a,b)  => {
            return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
        }));
        orderedFeeds.push( ...feeds.filter((feed) => CommonFilters.filterByFinishedStatus(feed)).sort((a,b)  => {
            return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
        }));
        return orderedFeeds;
    },
    orderingChannels: () =>  (channels) => {
        let orderedChannels = [];
        orderedChannels.push( ...channels.filter((channel) => CommonFilters.filterByRunningStatus(channel)).sort((a,b)  => {
            return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
        }));
        //we need to change filterByAvailableFeeds name to filterByAvailableItems in /gcmcn-front-common/src/components/common-filters.js
        orderedChannels.push( ...channels.filter((channel) => CommonFilters.filterByAvailableFeeds(channel)).sort((a,b)  => {
            return new Date(b.confirmed ? b.confirmed_start_date : b.start_date) - new Date(a.confirmed ? a.confirmed_start_date : a.start_date);
        }));
        orderedChannels.push( ...channels.filter((channel) => CommonFilters.filterByFailedStatus(channel)).sort((a,b)  => {
            return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
        }));
        orderedChannels.push( ...channels.filter((channel) => CommonFilters.filterByFinishedStatus(channel)).sort((a,b)  => {
            return new Date(b.confirmed_start_date) - new Date(a.confirmed_start_date);
        }));
        return orderedChannels;
    },
    orderingFeedResources: () =>  (resources) => {
        let orderedResources = [];
        orderedResources.push( ...resources.filter((resource) => CommonFilters.filterByRunningStatus(resource)).sort((a,b)  => {
            return a.display_name.localeCompare(b.display_name);
        }));
        //we need to change filterByAvailableFeeds name to filterByAvailableItems in /gcmcn-front-common/src/components/common-filters.js
        orderedResources.push( ...resources.filter((resource) => CommonFilters.filterByAvailableFeeds(resource)).sort((a,b)  => {
            return a.display_name.localeCompare(b.display_name);
        }));
        orderedResources.push( ...resources.filter((resource) => resource.status === 'STOPPING').sort((a,b)  => {
            return a.display_name.localeCompare(b.display_name);
        }));
        orderedResources.push( ...resources.filter((resource) => resource.status === 'STOPPED').sort((a,b)  => {
            return a.display_name.localeCompare(b.display_name);
        }));
        orderedResources.push( ...resources.filter((resource) => CommonFilters.filterByFailedStatus(resource)).sort((a,b)  => {
            return a.display_name.localeCompare(b.display_name);
        }));
        orderedResources.push( ...resources.filter((resource) => CommonFilters.filterByFinishedStatus(resource)).sort((a,b)  => {
            return a.display_name.localeCompare(b.display_name);
        }));
        return orderedResources;
    },

    awsregionsSortedByName (state, getters){
        return getters.awsregions.sort((a,b) =>{
            if(a.display_name < b.display_name) { return -1; }
            if(a.display_name > b.display_name) { return 1; }
            return 0;
        });
    },
    regexIp (){
        return /((^\s*((([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]))\s*$)|(^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$))/;
    },
    alertsFetchSidebarFilter (){
        return { acquited: false, level__in: 'CRITICAL,WARNING,ERROR,INFO' };
    },
    emailRegex (){
        return /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    },
    sortedLatencies (state, getters){
        return getters.latencies.sort((a,b) =>{
            if(a.value_ms < b.value_ms) { return -1; }
            if(a.value_ms > b.value_ms) { return 1; }
            return 0;
        });
    },
    enableSidebarCollapse(state, getters) {
        if (getters.windowWidth > 1024) {
            return false;
        } else {
            return true;
        }
    },
    alarmsUsersPermission(state, getters, rootState, rootGetters){
        return getters.userIsEntityAdmin() || getters.userIsAtLeastAdmin;
    },
    allAlarms(state, getters, rootState, rootGetters) {
        let alarms = getters.alarms;
        if(getters.userIsEntityAdmin()){
            alarms = alarms.filter(
                alarm => getters.administrableEntitiesUids.includes(alarm.scopes.entity_uid)
            );
        }
        let activeAlarms = alarms.filter((alarm) => alarm.active === true).slice();
        activeAlarms.sort((a,b) => {
            if(new Date(a.modification_date) < new Date(b.modification_date)) { return -1; }
            if(new Date(a.modification_date) > new Date(b.modification_date)) { return 1; }
            return 0;
        });
        let inactiveAlarms = alarms.filter((alarm) => alarm.active === false).slice();
        inactiveAlarms.sort((a,b) => {
            if(new Date(a.modification_date) < new Date(b.modification_date)) { return -1; }
            if(new Date(a.modification_date) > new Date(b.modification_date)) { return 1; }
            return 0;
        });
        return activeAlarms.concat(inactiveAlarms);
    },
    authorizedCharactersRegex() {
        return /^[-_:\.A-Za-z0-9\s]*$/;
    },
    monitoringRemainingTime(state){
        return state.monitoringRemainingTime;
    },
    monitoringChannelsPerPage(state){
        return state.monitoringChannelsPerPage;
    },
    displayAlertInLocalTime(){
        return false;
    },
    userIsEntityAdmin : (state, getters) =>(entityUid=null, userToCheck=null)=>{
        let user = userToCheck?userToCheck:getters.currentUser;
        let currentUserIsEntityAdmin = false;
        if(entityUid){
            currentUserIsEntityAdmin = getters.groups.some(
                group =>
                    group.is_admin_group === true
                    && group.entity_uid === entityUid
                    && group.members_uid.includes(user.uid)
            );
        }else{
            currentUserIsEntityAdmin = getters.groups.some(
                group =>
                    group.is_admin_group === true
                    && group.members_uid.includes(user.uid)
            );
        }
        return user.level.toLowerCase() === 'manager' && currentUserIsEntityAdmin;
    },
    administrableEntitiesUids(state, getters){
        let user = getters.currentUser;
        let userLevel = user.level.toLowerCase();
        if(userLevel === 'superuser' || userLevel === 'admin'){
            return getters.entities.map(entity => entity.uid);
        }
        return getters.groups.filter(
            group =>
                group.is_admin_group === true
                && group.members_uid.includes(user.uid)
        ).map(group => {
            return group.entity_uid;
        });
    },
    selectedEntitiesForFilter(state){
        return state.entitiesFilter;
    },
    selectedUniversesForFilter(state){
        return state.universesFilter;
    },
    selectedEventsForFilter(state){
        return state.eventsFilter;
    },
    selectedTakersForFilter(state){
        return state.takersFilter;
    },

};



// WEBPACK FOOTER //
// ./src/store/getters.js